import {
  Entity,
  PrimaryGeneratedColumn,
  Column,
  CreateDateColumn,
  UpdateDateColumn,
  VersionColumn,
} from "typeorm";
import { VehicleIssueStatusenum } from "@project-management-system/shared-models";

@Entity("vehicle_issue")
export class VehicleissueEntity {
  @PrimaryGeneratedColumn({
    name: "id",
  })
  id: number;

  @Column({
    name: "vehicle_id",
  })
  vehicleId: number;

  @Column({
    name: "employee_id",
  })
  employeeId: number;

  @Column({
    name: "title",
  })
  title: string;

  @Column({
    name: "description",
    nullable: true
  })
  description: string;

  @Column({ nullable: true, name: "file_upload" })
  fileUpload: string;

  @Column({
    name: "priority",
  })
  priority: string;

  @Column({
    name: "due_date",
  })
  dueDate: Date;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active",
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime",
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user",
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: "datetime",
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag",
  })
  versionFlag: number;

  @Column("enum", {
    name: "Vehicle_Status",
    enum: VehicleIssueStatusenum,
  })
  vehicleStatus: VehicleIssueStatusenum;
}
